import { useEffect, useState } from "react";
import useOrientationLock from "../../hooks/useOrientationLock";
import RotateDeviceOverlay from "../../components/RotateDeviceOverlay";
import { Snackbar } from "../../components/Snackbar";
import {
  DEFAULT_SNACKBAR,
  ERROR_CREDENTIALS,
  ERROR_EMPTY_CREDENTIALS,
  SUCCESS_CREDENTIALS,
} from "../../utils/snackbar";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { useNavigate } from "react-router-dom";
import { useMoodleV2 } from "../../contexts/moodle";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { useConfig } from "../../contexts/config";
import LoginFormV2 from "../../components/LoginForm";
import ForgotPasswordForm from "../../components/LoginForm/ForgotPasswordForm";
import { useTheme } from "../../contexts/ThemeContext";
import "./styles.css";
import { readableColor } from "polished";
import ForcePasswordChangeForm from "../../components/LoginForm/ForcePasswordChangeForm";
import StatsSection from "../../components/LoginCounter";
import BackgroundGrid from "../../components/Login/BackgroundGrid";
import logoAbastible from "../../assets/logoabastible.webp";
import fondo from "../../assets/Fondo_desktop.jpg";
import formFlame from "../../assets/form_flame.webp";

const Login = () => {
  const { showOverlay } = useOrientationLock("portrait");
  const [snackbar, setSnackbar] = useState(DEFAULT_SNACKBAR);
  const [credentials, setCredentials] = useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const auth = useAuth();
  const navigate = useNavigate();
  const moodlev2 = useMoodleV2();
  const { config } = useConfig();
  const [showForcePasswordChange, setShowForcePasswordChange] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, [moodlev2]);

/*   useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "imagen2",
        "bg-auto",
        "bigDesktop:bg-cover"
      );
    };
    // eslint-disable-next-line
  }, []); */

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    // Si username y password son iguales, mostrar el formulario de cambio
    /* if (clean_username === credentials.password && clean_username !== "tipddyalumno") {
    setShowForcePasswordChange(true);
    return;
  } */

    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");
        navigate("/listcourses");
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);

  return (
    <>
      <RotateDeviceOverlay show={showOverlay} />
      <div
      className="w-full h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* <BackgroundGrid
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        style={{
          zIndex: 0,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
        }}
        strokeColor={
          theme.mode === "dark"
            ? "hsla(0, 37%, 100%, 0.6)"
            : "hsla(0, 0%, 14%, 0.3)"
        }
      /> */}

      {/* Main Container */}
      <div className="z-10 w-full mx-auto px-4 laptop:px-8">
        <div className="grid grid-cols-1 laptop:grid-cols-12 gap-8 laptop:gap-12 items-center min-h-[90vh]">
          {/* Left Column - Login Form */}
          <div className="laptop:col-span-5 flex flex-col items-center justify-center max-h-[75vh]">
            <div className="relative w-full max-w-[56rem] h-full">
              {/* Logo alineado con el borde izquierdo de la tarjeta */}
              <div className="absolute bottom-full left-0 mb-12">
                <img
                  src={logoAbastible}
                  alt="Abastible"
                  className="h-12 tablet:h-48 pl-3 w-auto object-contain"
                  style={{ maxWidth: "370px" }}
                />
              </div>

              {/* Glow Effect */}
              <div
                className={`absolute inset-0 bg-gradient-to-r from-[${
                  theme?.colors.tertiary_dark || "#44BCF9"
                }] to-[${
                  theme?.colors.text_login_light || "#E63289"
                }] rounded-3xl blur-xl opacity-20`}
              ></div>

              {/* Form Container */}
              <div
                className={`relative h-full bg-gradient-to-br from-[${
                  theme?.colors.tertiary_dark || "#8C7FC8"
                }] to-[${
                  theme?.colors.text_login_light || "#7B6BC6"
                }] p-1 rounded-3xl`}
              >
                <div
                  style={{
                    background: "linear-gradient(45deg,#fe5000,#f56e00 50%,#ed8a00)",
                    paddingBottom: "4.5rem",
                  }}
                  className="relative rounded-[1.4rem] h-full px-2 tablet:p-8 shadow-2xl laptop:min-h-[45vh] overflow-hidden"
                >
                  <div
                    aria-hidden="true"
                    style={{
                      backgroundImage: `url(${formFlame})`,
                      backgroundPosition: "50%",
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      height: "100%",
                    }}
                    className="absolute inset-0 pointer-events-none select-none"
                  />
                  {/* Header */}
                  <div className="text-center mb-8">
                    <div className="text-center mb-8 w-full h-[11rem] p-3">
                      <h2 className="text-4xl tablet:text-6xl font-[900] antialiased text-white tracking-wider pt-12">
                        Iniciar Sesión
                      </h2>
                    </div>
                  </div>

                  {/* Login Form */}
                  {!showForgotPassword && !showForcePasswordChange && (
                    <LoginFormV2
                      handleChange={handleChange}
                      credentials={credentials}
                      handleSubmit={handleSubmit}
                      loading={loading}
                      setShowForgotPassword={setShowForgotPassword}
                      theme={theme}
                    />
                  )}

                  {/* Forgot Password Form */}
                  {(showForgotPassword || showForcePasswordChange) && (
                    <ForgotPasswordForm
                      onBackToLogin={() => {
                        setShowForgotPassword(false);
                        setShowForcePasswordChange(false);
                      }}
                      showForcePasswordChange={showForcePasswordChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Mensaje promocional */}
          <div className="login-promo-section laptop:col-span-7 items-center justify-center min-h-[90vh] px-6 desktop:px-10 translate-y-[14rem]">
            <div className="w-full max-w-[57rem] text-white text-left drop-shadow-[0_4px_18px_rgba(0,0,0,0.35)]">
              <p className="text-[2.4rem] leading-none font-light tracking-tight desktop:text-[3rem]">
                Acceso a la plataforma virtual
              </p>
              <h1 className="mt-3 text-[3.25rem] leading-[0.95] font-extrabold tracking-tight desktop:text-[6.25rem]">
                El crecimiento de la empresa comienza contigo.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </div>
    </>
  );
};

export default Login;
